import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuth } from "../../context/AuthContext";

const GOOGLE_ERROR = "Չհաջողվեց մուտք գործել Google-ով։";

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.7 6c4.5-4.2 6.9-10.3 6.9-17.7z" />
    <path fill="#FBBC05" d="M10.5 28.7a14.5 14.5 0 0 1 0-9.4l-7.9-6.1a24 24 0 0 0 0 21.6l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.7-6c-2.1 1.4-4.9 2.3-8.2 2.3-6.3 0-11.6-4.1-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

const GoogleButton = ({ onSuccess, onError, onTwoFactor }) => {
  const { googleLogin } = useAuth();
  const [busy, setBusy] = useState(false);

  const start = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      try {
        const result = await googleLogin(access_token);
        if (result.twoFactor && onTwoFactor) onTwoFactor(result.challenge);
        else onSuccess();
      } catch {
        onError(GOOGLE_ERROR);
        setBusy(false);
      }
    },
    onError: () => {
      onError(GOOGLE_ERROR);
      setBusy(false);
    },
    onNonOAuthError: () => setBusy(false),
  });

  if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) return null;

  return (
    <div className="auth-google">
      <div className="auth-divider">կամ</div>
      <button
        type="button"
        className="auth-google-btn"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          start();
        }}
      >
        <GoogleIcon />
        <span>Շարունակել Google-ով</span>
      </button>
    </div>
  );
};

export default GoogleButton;
